import React from 'react';

/**
 * Used to create uniform modal formatting in Conjunction with ModalHeader.js, and ModalFooter.js.
 *
 * Props
 * - modalSize - size of modal, default is 'md'
 */

type Props = {
  /**
   * @default md
   */
  modalSize?: string;
};

const ModalContainer: React.FC<React.PropsWithChildren<Props>> = ({
  modalSize = 'sm',
  children,
}) => {
  return (
    <div className={`modal-dialog modal-dialog-centered modal-${modalSize}`}>
      <div className="modal-content">{children}</div>
    </div>
  );
};

export default ModalContainer;
